import usaStates from "../const/usaStates";
var stateOptions = usaStates.map(function (state) { return ({
    label: state,
    value: state,
}); });
export default stateOptions;
